import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fetchInventaireFournisseurs } from "../../../store/actions/atelierInventaireActions"
import { COLORS } from "../../../utilities/Constants"
import { generalStyles as gs } from "../../styles/styles"
import { tableStyles } from "../../styles/tableStyles"
import Loader from "../../basics/Loader"
import FournisseurModalV2 from "./FournisseurModalV2"

const fmt2 = (v) => {
	const n = Number(v)
	return Number.isNaN(n) ? "—" : n.toFixed(2)
}

const styles = {
	header: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		marginBottom: 16,
	},
	title: { fontSize: 15, fontWeight: 600, color: COLORS.text },
	count: { fontSize: 13, color: COLORS.textLight },
	chip: {
		display: "inline-flex",
		alignItems: "center",
		padding: "2px 9px",
		borderRadius: 99,
		fontSize: 11,
		fontWeight: 500,
		color: COLORS.accent,
		backgroundColor: COLORS.accentLight,
	},
}

const FournisseurRow = ({ fournisseur, index, onOpen }) => {
	const [hover, setHover] = useState(false)
	const bg = hover ? tableStyles.rowHover : tableStyles.rowBg(index)
	const infos = fournisseur.infos || {}
	return (
		<tr
			onDoubleClick={() => onOpen(fournisseur)}
			onMouseEnter={() => setHover(true)}
			onMouseLeave={() => setHover(false)}
			style={{
				backgroundColor: bg,
				cursor: "pointer",
				transition: "background-color 0.12s",
			}}
		>
			<td style={{ ...tableStyles.td, fontWeight: 500 }}>
				{fournisseur.nom || "—"}
			</td>
			<td style={tableStyles.td}>
				<span style={styles.chip}>{infos.nbCommandes ?? 0}</span>
			</td>
			<td style={tableStyles.tdRight}>{fmt2(infos.total)} CHF</td>
		</tr>
	)
}

// Onglet "Fournisseurs" de l'inventaire V2 : table (nom + nb de commandes +
// total acheté) + édition par modal. Réutilise l'infra Redux existante.
const FournisseursV2 = () => {
	const dispatch = useDispatch()
	const fournisseurs = useSelector((s) => s.atelierInventaire.fournisseurs)
	const fetchState = useSelector(
		(s) => s.atelierInventaire.fetchFournisseurs,
	)
	const [editing, setEditing] = useState(null) // fournisseur | null

	useEffect(() => {
		dispatch(fetchInventaireFournisseurs())
	}, [dispatch])

	const sorted = [...(fournisseurs || [])].sort((a, b) =>
		(a.nom || "").localeCompare(b.nom || "", "fr"),
	)
	const loading = fetchState.loading && sorted.length === 0

	return (
		<>
			{editing && (
				<FournisseurModalV2
					fournisseur={editing}
					onClose={() => setEditing(null)}
				/>
			)}
			<div style={styles.header}>
				<div style={{ display: "flex", alignItems: "baseline", gap: 10 }}>
					<span style={styles.title}>Fournisseurs</span>
					<span style={styles.count}>{sorted.length}</span>
				</div>
				<button style={gs.btnPrimary} onClick={() => setEditing({})}>
					+ Nouveau fournisseur
				</button>
			</div>
			<div style={tableStyles.container}>
				{loading ? (
					<Loader variant="ring" message="Chargement…" />
				) : sorted.length === 0 ? (
					<div style={tableStyles.empty}>Aucun fournisseur.</div>
				) : (
					<table style={tableStyles.table}>
						<thead>
							<tr>
								<th style={tableStyles.th}>Nom</th>
								<th style={tableStyles.th}>Commandes</th>
								<th style={tableStyles.thRight}>Total acheté</th>
							</tr>
						</thead>
						<tbody>
							{sorted.map((fournisseur, index) => (
								<FournisseurRow
									key={fournisseur.id}
									fournisseur={fournisseur}
									index={index}
									onOpen={setEditing}
								/>
							))}
						</tbody>
					</table>
				)}
			</div>
		</>
	)
}

export default FournisseursV2
